import React from "react";
import { Link } from "react-router-dom";
import "./compoments.css";

const NavigationBar = () => {
  return (
<nav className="navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        {/* Brand */}
        <span className="navbar-brand mb-0 h1 display-1">Diamonds And Rust</span>

        {/* Burger button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                Αρχική
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/chatroom">
                Chat Room
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;